import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import{Form1Component} from './components/form1/form1.component';


export const FormsRoutes: Routes = [
  // { path: 'app-form1-component', redirectTo: 'app-form1' },
  // { path: 'app-form1-component', component: Form1Component },

];